<template>
  <div class="upload-page">
    <navbarBox></navbarBox>
    <silderbarBox></silderbarBox>
    <div class="upload-box" v-if="$session.get('role') !== 'Customer'">
      <v-container fluid style="height: 100%">
        <v-row>
          <v-col>
            <v-row align="start" justify="center" class="size-box">
              <v-col md="11" sm="11" lg="11" cols="11">
                <v-stepper
                  v-model="current_step"
                  :vertical="vertical"
                  :alt-labels="altLabels"
                >
                  <template>
                    <v-stepper-header>
                      <template v-for="n in steps">
                        <v-stepper-step
                          :key="`${n}-step`"
                          :complete="current_step > n"
                          :step="n"
                          :editable="editable"
                          >{{ name_steps[n - 1] }}</v-stepper-step
                        >
                        <v-divider v-if="n !== steps" :key="n"></v-divider>
                      </template>
                    </v-stepper-header>
                    <v-stepper-items>
                      <v-stepper-content class="pt-0" step="1">
                        <v-data-table
                          :headers="headers_customer"
                          :items="datasets_customer"
                          :search="search_customer"
                          hide-default-footer
                          :items-per-page="1000"
                          class="elevation-1"
                          height="550"
                        >
                          <template v-slot:top>
                            <v-toolbar flat color="white">
                              <v-toolbar-title
                                >รายชื่อพาร์เนอร์</v-toolbar-title
                              >
                              <v-divider
                                class="mx-4"
                                inset
                                vertical
                              ></v-divider>
                              <v-text-field
                                v-model="search_customer"
                                append-icon="mdi-magnify"
                                label="ค้นหา"
                                single-line
                                hide-details
                              ></v-text-field>
                              <v-spacer></v-spacer>
                              <div
                                v-for="(l, idx) in customer_level_select"
                                :key="idx"
                              >
                                <v-checkbox
                                  @change="getAllCustomers()"
                                  v-model="customer_level"
                                  class="mx-2"
                                  :label="l.level_name"
                                  :value="l.level"
                                ></v-checkbox>
                              </div>
                            </v-toolbar>
                          </template>
                          <template v-slot:item="{ item }">
                            <tr @click="getCustomerID(item)">
                              <td class="text-left">{{ item.taxid }}</td>
                              <td class="text-left">{{ item.cust_name }}</td>
                              <td class="text-left">{{ item.contact }}</td>
                              <td class="text-center">{{ item.mobile }}</td>
                              <td class="text-center">
                                {{
                                  item.count_project
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                }}
                              </td>
                              <td class="text-right">
                                {{
                                  item.sum_project_value
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                }}
                              </td>
                            </tr>
                          </template>
                          <template v-slot:no-data>
                            <v-btn
                              color="#141824"
                              small
                              @click="getAllCustomers()"
                            >
                              <span style="color: #ffb600">ไม่พบข้อมูล</span>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-stepper-content>
                      <v-stepper-content class="pt-0" step="2">
                        <v-data-table
                          :headers="headers_project"
                          hide-default-footer
                          :items-per-page="100"
                          :items="datasets_project"
                          :search="search_project"
                          class="elevation-1"
                          height="550"
                        >
                          <template v-slot:top>
                            <v-toolbar flat color="white">
                              <v-toolbar-title>{{
                                select_customer.name
                              }}</v-toolbar-title>
                              <v-divider
                                class="mx-4"
                                inset
                                vertical
                              ></v-divider>
                              <v-text-field
                                v-model="search_project"
                                append-icon="mdi-magnify"
                                label="ค้นหา"
                                single-line
                                hide-details
                              ></v-text-field>
                              <v-spacer></v-spacer>
                              <v-btn
                                @click="backToCustomer()"
                                color="error"
                                small
                              >
                                <v-icon small style="margin: 4%"
                                  >mdi-undo</v-icon
                                >ย้อนกลับ
                              </v-btn>
                            </v-toolbar>
                          </template>
                          <template v-slot:item="{ item }">
                            <tr @click="getProjectID(item)">
                              <td class="text-left">{{ item.project_code }}</td>
                              <td class="text-left">
                                {{ item.project_shortname }}
                              </td>
                              <td class="text-center">
                                <span v-if="item.contract !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.workload !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.plan !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.transfer !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.notice !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.moa !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.loan !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.other !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                            </tr>
                          </template>
                          <template v-slot:no-data>
                            <v-btn
                              color="#141824"
                              small
                              @click="getAllProjectsByCustomer()"
                            >
                              <span style="color: #ffb600">ไม่พบข้อมูล</span>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-stepper-content>
                      <v-stepper-content class="pt-0" step="3">
                        <v-container>
                          <v-row>
                            <v-col>
                              <v-card color="#ffffff">
                                <v-list-item style="background-color: #141824">
                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="headline"
                                      style="color: #ffb600; padding: 1%"
                                      >สัญญาเลขที่ {{ select_project.code }} ของ
                                      {{
                                        select_customer.name
                                      }}</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                                <v-card-text style="padding: 2%">
                                  <v-card max-width="100%" class="mx-auto">
                                    <v-system-bar lights-out></v-system-bar>
                                    <v-carousel
                                      v-model="slide_carousel"
                                      :continuous="false"
                                      :show-arrows="false"
                                      hide-delimiter-background
                                      delimiter-icon="mdi-file-document-outline"
                                      height="100%"
                                      v-if="allFiles.length !== 0"
                                    >
                                      <v-carousel-item
                                        v-for="(slide, i) in allFiles"
                                        :key="i"
                                      >
                                        <v-sheet height="100%" tile>
                                          <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center"
                                          >
                                            <pdf :src="slide.doc_name"></pdf>
                                          </v-row>
                                        </v-sheet>
                                      </v-carousel-item>
                                    </v-carousel>
                                    <v-carousel
                                      :continuous="false"
                                      :show-arrows="false"
                                      hide-delimiter-background
                                      height="700"
                                      v-else
                                    >
                                      <v-carousel-item
                                        v-for="(slide, i) in slides"
                                        :key="i"
                                      >
                                        <v-sheet height="100%" tile>
                                          <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center"
                                          >
                                            <div
                                              class="display-1"
                                              style="color: #ffb600"
                                            >
                                              {{ slide }}
                                            </div>
                                          </v-row>
                                        </v-sheet>
                                      </v-carousel-item>
                                    </v-carousel>
                                    <v-list
                                      two-line
                                      v-if="allFiles.length !== 0"
                                    >
                                      <v-list-item>
                                        <v-list-item-avatar>
                                          <v-img
                                            :src="
                                              require('../assets/avatar-human-male-profile-user-icon-518358.png')
                                            "
                                          ></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                          <v-list-item-title>{{
                                            type_show
                                          }}</v-list-item-title>
                                          <v-list-item-subtitle>{{
                                            time
                                          }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                          <v-btn
                                            class="float-right mt-2"
                                            @click="zoomDoc()"
                                            color="success"
                                            small
                                          >
                                            <v-icon small
                                              >mdi-magnify-plus</v-icon
                                            >
                                          </v-btn>
                                          <v-btn
                                            class="float-right mt-2"
                                            @click="dialog_delete = true"
                                            color="error"
                                            small
                                          >
                                            <v-icon small>mdi-delete</v-icon>
                                          </v-btn>
                                        </v-list-item-action>
                                      </v-list-item>
                                    </v-list>
                                  </v-card>
                                </v-card-text>
                              </v-card>
                            </v-col>
                            <v-col
                              lg="3"
                              md="4"
                              sm="12"
                              cols="12"
                              v-if="
                                $session.get('role') === 'Admin' ||
                                $session.get('role') === 'Operation'
                              "
                            >
                              <v-card color="#ffffff">
                                <v-list-item style="background-color: #141824">
                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="headline"
                                      style="color: #ffb600"
                                      >เครื่องมือ</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                                <v-card-text style="padding: 1%">
                                  <v-container>
                                    <v-row>
                                      <v-col lg="12" md="12" sm="12" cols="12">
                                        <v-select
                                          class="select-style"
                                          style="margin-right: 3%"
                                          hide-details
                                          outlined
                                          dense
                                          prepend-icon="mdi-file-settings"
                                          item-value="type"
                                          item-text="name_type"
                                          v-model="form.type"
                                          :items="types_select"
                                          label="ประเภทไฟล์เอกสาร"
                                        ></v-select>
                                      </v-col>
                                      <v-col lg="12" md="12" sm="12" cols="12">
                                        <v-file-input
                                          accept=".pdf"
                                          style="margin-right: 3%"
                                          multiple
                                          outlined
                                          dense
                                          @change="inputFile()"
                                          label="PDF"
                                          :show-size="1000"
                                          v-model="form.file_upload"
                                          hide-details
                                          placeholder="คลิกเพื่อเลือกไฟล์เอกสารที่ต้องการ"
                                        >
                                          <template v-slot:selection="{ text }">
                                            <v-chip
                                              small
                                              label
                                              color="success"
                                              >{{ text }}</v-chip
                                            >
                                          </template>
                                        </v-file-input>
                                      </v-col>
                                      <v-col
                                        lg="12"
                                        md="12"
                                        sm="12"
                                        cols="12"
                                        v-if="form.type === 'DBD'"
                                      >
                                        <v-menu
                                          v-model="menu2"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="290px"
                                        >
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-text-field
                                              v-model="form.exp"
                                              label="วันที่หมดอายุหนังสือรับรองบริษัท"
                                              prepend-icon="mdi-calendar"
                                              placeholder="คลิกเพื่อเลือกวันที่"
                                              readonly
                                              outlined
                                              dense
                                              v-bind="attrs"
                                              v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <v-date-picker
                                            v-model="form.exp"
                                            @input="menu2 = false"
                                          ></v-date-picker>
                                        </v-menu>
                                      </v-col>
                                      <v-col
                                        class="text-center"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                        cols="12"
                                      >
                                        <v-btn
                                          color="success"
                                          small
                                          @click="confirm()"
                                        >
                                          <v-icon small
                                            >mdi-content-save</v-icon
                                          >
                                          <b class="ml-2">บันทึก</b>
                                        </v-btn>
                                        <span style="margin: 1%"></span>
                                        <v-btn
                                          color="info"
                                          small
                                          @click="preview()"
                                        >
                                          <v-icon small>mdi-eye</v-icon>
                                          <b class="ml-2">ภาพตัวอย่าง</b>
                                        </v-btn>
                                        <span style="margin: 1%"></span>
                                        <v-btn
                                          color="error"
                                          small
                                          @click="backToProject()"
                                        >
                                          <v-icon small>mdi-undo</v-icon>
                                          <b class="ml-2">ย้อนกลับ</b>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-stepper-content>
                    </v-stepper-items>
                  </template>
                </v-stepper>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="upload-box" v-else>
      <v-container fluid style="height: 100%">
        <v-row>
          <v-col>
            <v-row align="start" justify="center" class="size-box">
              <v-col
                lg="11"
                md="11"
                cols="11"
                sm="11"
                v-if="$session.get('status') === 1"
              >
                <v-stepper
                  v-model="current_step"
                  :vertical="vertical"
                  :alt-labels="altLabels"
                >
                  <template>
                    <v-stepper-header>
                      <template v-for="n in steps">
                        <v-stepper-step
                          :key="`${n}-step`"
                          :complete="current_step > n"
                          :step="n"
                          :editable="editable"
                          >{{ name_steps[n - 1] }}</v-stepper-step
                        >
                        <v-divider v-if="n !== steps" :key="n"></v-divider>
                      </template>
                    </v-stepper-header>
                    <v-stepper-items>
                      <v-stepper-content class="pt-0" step="1">
                        <v-data-table
                          :headers="headers_project"
                          hide-default-footer
                          :items-per-page="100"
                          :items="datasets_project"
                          :search="search_project"
                          class="elevation-1"
                          height="550"
                        >
                          <template v-slot:top>
                            <v-toolbar flat color="white">
                              <v-toolbar-title>{{
                                select_customer.name
                              }}</v-toolbar-title>
                              <v-divider
                                class="mx-4"
                                inset
                                vertical
                              ></v-divider>
                              <v-text-field
                                v-model="search_project"
                                append-icon="mdi-magnify"
                                label="ค้นหา"
                                single-line
                                hide-details
                              ></v-text-field>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </template>
                          <template v-slot:item="{ item }">
                            <tr @click="getProjectID(item)">
                              <td class="text-left">{{ item.project_code }}</td>
                              <td class="text-left">
                                {{ item.project_shortname }}
                              </td>
                              <td class="text-center">
                                <span v-if="item.contract !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.workload !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.plan !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.transfer !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.notice !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.moa !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.loan !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                              <td class="text-center">
                                <span v-if="item.other !== 0">
                                  <v-icon small color="success"
                                    >mdi-check-bold</v-icon
                                  >
                                </span>
                                <span v-else>
                                  <v-icon small color="error"
                                    >mdi-close-thick</v-icon
                                  >
                                </span>
                              </td>
                            </tr>
                          </template>
                          <template v-slot:no-data>
                            <v-btn
                              color="#141824"
                              small
                              @click="getAllProjectsByCustomer()"
                            >
                              <span style="color: #ffb600">ไม่พบข้อมูล</span>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-stepper-content>
                      <v-stepper-content class="pt-0" step="2">
                        <v-container>
                          <v-row>
                            <v-col>
                              <v-card color="#ffffff">
                                <v-list-item style="background-color: #141824">
                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="headline"
                                      style="color: #ffb600"
                                      >สัญญาเลขที่
                                      {{
                                        select_project.code
                                      }}</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                                <v-card-text style="padding: 2%">
                                  <v-card max-width="100%" class="mx-auto">
                                    <v-system-bar lights-out></v-system-bar>
                                    <v-carousel
                                      v-model="slide_carousel"
                                      :continuous="false"
                                      :show-arrows="false"
                                      hide-delimiter-background
                                      delimiter-icon="mdi-file-document-outline"
                                      height="100%"
                                      v-if="allFiles.length !== 0"
                                    >
                                      <v-carousel-item
                                        v-for="(slide, i) in allFiles"
                                        :key="i"
                                      >
                                        <v-sheet height="100%" tile>
                                          <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center"
                                          >
                                            <pdf :src="slide.doc_name"></pdf>
                                          </v-row>
                                        </v-sheet>
                                      </v-carousel-item>
                                    </v-carousel>
                                    <v-carousel
                                      :continuous="false"
                                      :show-arrows="false"
                                      hide-delimiter-background
                                      height="700"
                                      v-else
                                    >
                                      <v-carousel-item
                                        v-for="(slide, i) in slides"
                                        :key="i"
                                      >
                                        <v-sheet height="100%" tile>
                                          <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center"
                                          >
                                            <div
                                              class="display-1"
                                              style="color: #ffb600"
                                            >
                                              {{ slide }}
                                            </div>
                                          </v-row>
                                        </v-sheet>
                                      </v-carousel-item>
                                    </v-carousel>
                                    <v-list
                                      two-line
                                      v-if="allFiles.length !== 0"
                                    >
                                      <v-list-item>
                                        <v-list-item-avatar>
                                          <v-img
                                            :src="
                                              require('../assets/avatar-human-male-profile-user-icon-518358.png')
                                            "
                                          ></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                          <v-list-item-title>{{
                                            type_show
                                          }}</v-list-item-title>
                                          <v-list-item-subtitle>{{
                                            time
                                          }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                          <v-btn
                                            class="float-right mt-2"
                                            @click="zoomDoc()"
                                            color="success"
                                            small
                                          >
                                            <v-icon small
                                              >mdi-magnify-plus</v-icon
                                            >
                                          </v-btn>
                                          <v-btn
                                            class="float-right mt-2"
                                            @click="dialog_delete = true"
                                            color="error"
                                            small
                                          >
                                            <v-icon small>mdi-delete</v-icon>
                                          </v-btn>
                                        </v-list-item-action>
                                      </v-list-item>
                                    </v-list>
                                  </v-card>
                                </v-card-text>
                              </v-card>
                            </v-col>
                            <v-col lg="3" md="4" sm="12" cols="12">
                              <v-card color="#ffffff">
                                <v-list-item style="background-color: #141824">
                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="headline"
                                      style="color: #ffb600"
                                      >เครื่องมือ</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                                <v-card-text style="padding: 1%">
                                  <v-container>
                                    <v-row>
                                      <v-col lg="12" md="12" sm="12" cols="12">
                                        <v-select
                                          class="select-style"
                                          style="margin-right: 3%"
                                          hide-details
                                          outlined
                                          prepend-icon="mdi-file-settings"
                                          item-value="type"
                                          item-text="name_type"
                                          v-model="form.type"
                                          :items="types_select"
                                          label="ประเภทไฟล์เอกสาร"
                                        ></v-select>
                                      </v-col>
                                      <v-col lg="12" md="12" sm="12" cols="12">
                                        <v-file-input
                                          accept=".pdf"
                                          style="margin-right: 3%"
                                          multiple
                                          outlined
                                          @change="inputFile()"
                                          label="PDF"
                                          :show-size="1000"
                                          v-model="form.file_upload"
                                          hide-details
                                          placeholder="คลิกเพื่อเลือกไฟล์เอกสารที่ต้องการ"
                                        >
                                          <template v-slot:selection="{ text }">
                                            <v-chip
                                              small
                                              label
                                              color="success"
                                              >{{ text }}</v-chip
                                            >
                                          </template>
                                        </v-file-input>
                                      </v-col>
                                      <v-col
                                        class="text-center"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                        cols="12"
                                      >
                                        <v-btn
                                          color="success"
                                          small
                                          @click="confirm()"
                                        >
                                          <v-icon small
                                            >mdi-content-save</v-icon
                                          >
                                          <b class="ml-2">บันทึก</b>
                                        </v-btn>
                                        <span style="margin: 1%"></span>
                                        <v-btn
                                          color="info"
                                          small
                                          @click="preview()"
                                        >
                                          <v-icon small>mdi-eye</v-icon>
                                          <b class="ml-2">ภาพตัวอย่าง</b>
                                        </v-btn>
                                        <span style="margin: 1%"></span>
                                        <v-btn
                                          @click="backToProject()"
                                          color="error"
                                          small
                                        >
                                          <v-icon small>mdi-undo</v-icon>
                                          <b class="ml-2">ย้อนกลับ</b>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-stepper-content>
                    </v-stepper-items>
                  </template>
                </v-stepper>
              </v-col>
              <v-col lg="11" md="11" cols="11" sm="11" v-else>
                <v-container>
                  <v-row>
                    <v-col lg="9" md="8" sm="12" cols="12">
                      <v-card color="#ffffff">
                        <v-list-item style="background-color: #141824">
                          <v-list-item-content>
                            <v-list-item-title
                              class="headline"
                              style="color: #ffb600"
                              >ไฟล์เอกสาร</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-card-text style="padding: 2%">
                          <v-card max-width="100%" class="mx-auto">
                            <v-card-text>
                              <v-text-field
                                v-model="search_company"
                                append-icon="mdi-magnify"
                                label="คลิกเพื่อค้นหา"
                                outlined
                                hide-details
                              ></v-text-field>
                            </v-card-text>
                            <v-data-table
                              :search="search_company"
                              :headers="headers_company"
                              :items="allFiles"
                              :items-per-page="20"
                              class="elevation-1"
                            >
                              <template v-slot:[`item.actions`]="{ item }">
                                <v-row>
                                  <v-col>
                                    <v-btn
                                      class="mt-2"
                                      @click="zoomDoc(item.doc_name)"
                                      color="success"
                                      small
                                    >
                                      <v-icon small>mdi-magnify-plus</v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-data-table>
                            <!-- <v-system-bar lights-out></v-system-bar> -->
                            <!-- <v-carousel
                              v-model="slide_carousel"
                              :continuous="false"
                              :show-arrows="false"
                              hide-delimiter-background
                              delimiter-icon="mdi-file-document-outline"
                              height="100%"
                              v-if="allFiles.length !== 0"
                            >
                              <v-carousel-item
                                v-for="(slide, i) in allFiles"
                                :key="i"
                              >
                                <v-sheet height="100%" tile>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center"
                                  >
                                    <pdf :src="slide.doc_name"></pdf>
                                  </v-row>
                                </v-sheet>
                              </v-carousel-item>
                            </v-carousel>
                            <v-carousel
                              :continuous="false"
                              :show-arrows="false"
                              hide-delimiter-background
                              height="700"
                              v-else
                            >
                              <v-carousel-item
                                v-for="(slide, i) in slides"
                                :key="i"
                              >
                                <v-sheet height="100%" tile>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center"
                                  >
                                    <div
                                      class="display-1"
                                      style="color: #ffb600"
                                    >
                                      {{ slide }}
                                    </div>
                                  </v-row>
                                </v-sheet>
                              </v-carousel-item>
                            </v-carousel> -->
                            <!-- <v-list two-line v-if="allFiles.length !== 0">
                              <v-list-item>
                                <v-list-item-avatar>
                                  <v-img
                                    :src="
                                      require('../assets/avatar-human-male-profile-user-icon-518358.png')
                                    "
                                  ></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    user
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle></v-list-item-subtitle>
                                  <v-list-item-subtitle
                                    >ประเภทเอกสาร {{ type_show }} ณ วันที่
                                    {{ time }}</v-list-item-subtitle
                                  >
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-btn
                                    class="float-right mt-2"
                                    @click="zoomDoc()"
                                    color="success"
                                    small
                                  >
                                    <v-icon small>mdi-magnify-plus</v-icon>
                                  </v-btn>
                                  <v-btn
                                    class="float-right mt-2"
                                    @click="dialog_delete = true"
                                    color="error"
                                    small
                                  >
                                    <v-icon small>mdi-delete</v-icon>
                                  </v-btn>
                                </v-list-item-action>
                              </v-list-item>
                            </v-list> -->
                          </v-card>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col lg="3" md="4" sm="12" cols="12">
                      <v-card color="#ffffff">
                        <v-list-item style="background-color: #141824">
                          <v-list-item-content>
                            <v-list-item-title
                              class="headline"
                              style="color: #ffb600"
                              >เครื่องมือ</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-card-text style="padding: 1%">
                          <v-container>
                            <v-row>
                              <v-col lg="12" md="12" sm="12" cols="12">
                                <v-select
                                  class="select-style"
                                  style="margin-right: 3%"
                                  hide-details
                                  outlined
                                  dense
                                  prepend-icon="mdi-file-settings"
                                  item-value="type"
                                  item-text="name_type"
                                  v-model="form.type"
                                  :items="types_select"
                                  label="ประเภทไฟล์เอกสาร"
                                ></v-select>
                              </v-col>
                              <v-col lg="12" md="12" sm="12" cols="12">
                                <v-autocomplete
                                  v-model="form.arcode"
                                  hide-details
                                  :items="arcode"
                                  outlined
                                  dense
                                  prepend-icon="mdi-file-settings"
                                  style="margin-right: 3%"
                                  :filter="customFilter"
                                  item-text="Name1"
                                  item-value="Code"
                                  label="รหัสลูกหนี้"
                                ></v-autocomplete>
                              </v-col>
                              <v-col lg="12" md="12" sm="12" cols="12">
                                <v-file-input
                                  accept=".pdf"
                                  style="margin-right: 3%"
                                  multiple
                                  outlined
                                  dense
                                  @change="inputFile()"
                                  label="PDF"
                                  :show-size="1000"
                                  v-model="form.file_upload"
                                  hide-details
                                  placeholder="คลิกเพื่อเลือกไฟล์เอกสารที่ต้องการ"
                                >
                                  <template v-slot:selection="{ text }">
                                    <v-chip small label color="success">{{
                                      text
                                    }}</v-chip>
                                  </template>
                                </v-file-input>
                              </v-col>
                              <v-col
                                lg="12"
                                md="12"
                                sm="12"
                                cols="12"
                                v-if="form.type === 'DBD'"
                              >
                                <v-menu
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="form.exp"
                                      label="วันที่หมดอายุหนังสือรับรองบริษัท"
                                      prepend-icon="mdi-calendar"
                                      placeholder="คลิกเพื่อเลือกวันที่"
                                      readonly
                                      outlined
                                      dense
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="form.exp"
                                    @input="menu2 = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col
                                class="text-center"
                                lg="12"
                                md="12"
                                sm="12"
                                cols="12"
                              >
                                <v-btn color="info" small @click="preview()">
                                  <v-icon small>mdi-eye</v-icon>
                                  <b class="ml-2">ภาพตัวอย่าง</b>
                                </v-btn>
                                <span style="margin: 1%"></span>
                                <v-btn color="success" small @click="confirm()">
                                  <v-icon small>mdi-content-save</v-icon>
                                  <b class="ml-2">บันทึก</b>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-dialog v-model="dialog_load" persistent max-width="400">
      <v-card color="#141824">
        <v-card-text style="color: #ffb600; padding: 3%">
          กำลังโหลดข้อมูล
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-3 mb-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_confirm" persistent max-width="350">
      <v-card>
        <v-list-item style="background-color: #141824">
          <v-list-item-content>
            <v-list-item-title class="headline" style="color: #ffb600"
              >ยืนยันการบันทึกข้อมูล ?</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-card-text style="color: #141824; padding: 3%">
          คุณต้องการยืนยันการบันทึกไฟล์เอกสารสัญญา
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-3 mb-2"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success accent-4" @click="uploadFiles()">
            <v-icon small>mdi-content-save</v-icon>
            <b class="ml-2">ยืนยัน</b>
          </v-btn>
          <v-btn
            small
            outlined
            color="error accent-4"
            @click="dialog_confirm = false"
          >
            <b>ยกเลิก</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_delete" persistent max-width="350">
      <v-card>
        <v-list-item style="background-color: #141824">
          <v-list-item-content>
            <v-list-item-title class="headline" style="color: #ffb600"
              >ยืนยันการลบข้อมูล ?</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-card-text style="color: #141824; padding: 3%">
          คุณต้องการยืนยันการลบไฟล์เอกสารสัญญา
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-3 mb-2"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success accent-4" @click="delDoc()">
            <v-icon small>mdi-content-save</v-icon>
            <b class="ml-2">ยืนยัน</b>
          </v-btn>
          <v-btn
            small
            outlined
            color="error accent-4"
            @click="dialog_delete = false"
          >
            <b>ยกเลิก</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlert" persistent max-width="300">
      <v-card>
        <v-card-title class="headline">
          <v-icon color="error" style="margin-right: 5%">{{
            alertMsg.icon
          }}</v-icon
          >ผิดพลาด
        </v-card-title>
        <v-card-text>{{ alertMsg.msg }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="close()">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_preview" persistent max-width="65%">
      <v-card>
        <v-list-item style="background-color: #141824">
          <v-list-item-content>
            <v-list-item-title class="headline" style="color: #ffb600"
              >ตัวอย่างไฟล์</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-card-text style="color: #141824; padding: 3%">
          <pdf :src="form.file_upload_base64"></pdf>
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-3 mb-2"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success accent-4" @click="dialog_preview = false">
            <v-icon small>mdi-check-bold</v-icon>
            <b class="ml-2">ตกลง</b>
          </v-btn>
          <v-btn small outlined color="error accent-4" @click="chooseNew()">
            <v-icon small>mdi-close-thick</v-icon>
            <b class="ml-2">เลือกใหม่</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import silderbarBox from "../components/silderbarBox";
import pdf from "vue-pdf";
export default {
  name: "Upload",
  components: { navbarBox, silderbarBox, pdf },
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    search_company: "",
    modal: false,
    menu2: false,
    arcode: [],
    slide_carousel: 0,
    dialog_delete: false,
    slides: ["ไม่พบไฟล์เอกสาร"],
    dialog_load: false,
    dialog_confirm: false,
    dialog_preview: false,
    vertical: false,
    altLabels: false,
    editable: false,
    current_step: 1,
    type: null,
    steps: 3,
    name_steps: ["พาร์เนอร์", "โครงการ", "อัพโหลดไฟล์เอกสาร"],
    headers_customer: [
      {
        text: "เลขที่ผู้เสียภาษี",
        align: "start",
        sortable: false,
        value: "taxid",
      },
      {
        text: "ชื่อพาร์เนอร์",
        align: "start",
        sortable: false,
        value: "cust_name",
      },
      {
        text: "ชื่อผู้ติดต่อ",
        align: "left",
        sortable: false,
        value: "contract",
      },
      {
        text: "เบอร์โทร",
        align: "center",
        sortable: false,
        value: "mobile",
      },
      {
        text: "โครงการทั้งหมด",
        align: "center",
        sortable: false,
        value: "count_project",
      },
      {
        text: "มูลค่าโครงการทั้งหมด",
        align: "right",
        sortable: false,
        value: "sum_project_value",
      },
    ],
    datasets_customer: [],
    search_customer: "",
    select_customer: {
      id: null,
      name: null,
    },
    allFiles: [],
    headers_project: [
      {
        text: "เลขที่สัญญาโครงการ",
        align: "start",
        sortable: false,
        value: "project_code",
      },
      {
        text: "ชื่อย่อโครงการ",
        align: "start",
        sortable: false,
        value: "project_shortname",
      },
      {
        text: "สัญญาจ้าง",
        align: "center",
        sortable: false,
        value: "project_value",
      },
      {
        text: "ใบปริมาณงาน",
        align: "center",
        sortable: false,
        value: "project_value",
      },
      {
        text: "แบบแปลน",
        align: "center",
        sortable: false,
        value: "project_value",
      },
      {
        text: "สัญญาโอนสิทธิ",
        align: "center",
        sortable: false,
        value: "project_value",
      },
      {
        text: "บอกกล่าวโอนสิทธิ",
        align: "center",
        sortable: false,
        value: "project_value",
      },
      {
        text: "MOA",
        align: "center",
        sortable: false,
        value: "project_value",
      },
      {
        text: "สัญญาเงินกู้",
        align: "center",
        sortable: false,
        value: "project_value",
      },
      {
        text: "อื่นๆ",
        align: "center",
        sortable: false,
        value: "project_value",
      },
    ],
    headers_company: [
      {
        text: "รหัสลูกหนี้",
        align: "start",
        sortable: false,
        value: "arcode",
      },
      {
        text: "ชื่อลูกหนี้",
        align: "start",
        sortable: false,
        value: "ar_name",
      },
      {
        text: "ประเภทเอกสาร",
        align: "start",
        sortable: false,
        value: "name_type",
      },
      {
        text: "เวลาที่เพิ่มเอกสาร",
        align: "start",
        sortable: false,
        value: "doc_datetime",
      },
      {
        text: "ดำเนินการ",
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    datasets_project: [],
    search_project: "",
    select_project: {
      id: null,
      name: null,
      code: null,
    },
    user: null,
    time: null,
    type_show: null,
    alertMsg: {
      icon: "",
      msg: "",
    },
    dialogAlert: false,
    types_select: [],
    customer_level_select: [],
    customer_level: [5, 4, 3, 2, 1, 0],
    form: {
      exp: null,
      arcode: null,
      file_upload: null,
      file_upload_base64: null,
      username_upload: null,
      fullname_upload: null,
      path_upload: null,
      customer_id: null,
      customer_name: null,
      project_id: null,
      project_code: null,
      project_shortname: null,
      ipaddress: null,
      browser: null,
      version: null,
      type: null,
      role: null,
      type_name: null,
      status: null,
    },
  }),
  watch: {
    slide_carousel(index) {
      this.user = this.allFiles[index].fullname;
      this.time = this.allFiles[index].doc_datetime.replace(/-/g, " ");
      this.type_show = this.allFiles[index].name_type;
    },
    dialog_load(val) {
      if (!val) return;
      setTimeout(() => (this.dialog_load = false), 1000);
    },
  },
  mounted() {
    if (
      this.$session.get("status") === 0 &&
      this.$session.get("role") === "Customer"
    ) {
      let db = "";
      let server = "";
      if (this.$session.get("username") === "subtawee") {
        db = "ST63";
        server = "110.77.145.175";
      } else if (this.$session.get("username") === "homemart") {
        db = "HML63";
        server = "183.88.221.160";
      } else if (this.$session.get("username") === "superhome") {
        db = "Superhome61";
        server = "110.77.145.181";
      }
      this.getArCode(db, server);
    } else {
      this.form.arcode = "";
    }
    if (this.$session.get("role") === "Customer") {
      this.select_customer.id = this.$session.get("username");
      this.select_customer.name = this.$session.get("fullname");
      this.getAllFiles();
      this.steps = 2;
      this.name_steps = ["โครงการ", "อัพโหลดไฟล์เอกสาร"];
      this.getAllProjectsByCustomer();
    }
    this.$axios.get(this.api + "/get/customer-level").then((res) => {
      for (let index = 0; index < res.data.response.length; index++) {
        this.customer_level_select.push(res.data.response[index]);
      }
    });
    this.$axios
      .post(this.api + "/get/type", { access: this.$session.get("role") })
      .then((res) => {
        for (let index = 0; index < res.data.response.length; index++) {
          this.types_select.push(res.data.response[index]);
        }
      });
    this.$axios
      .post(this.api + "/check_version", { version: this.version })
      .then((res) => {
        if (!res.data.status) {
          this.msgAlert(res.data.error, "mdi-alert-circle");
        }
      });
    this.getAllCustomers();
  },
  methods: {
    customFilter(item, queryText) {
      const textOne = item.Name1.toLowerCase();
      const textTwo = item.Code.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    preview() {
      if (
        this.form.file_upload_base64 !== null &&
        this.form.file_upload_base64 !== ""
      ) {
        this.dialog_preview = true;
      } else {
        alert("กรุณาเพิ่มไฟล์เอกสารก่อน");
      }
    },
    chooseNew() {
      this.dialog_preview = false;
      this.form.file_upload = null;
      this.form.file_upload_base64 = null;
    },
    msgAlert: function (msg, icon) {
      this.alertMsg.msg = msg;
      this.alertMsg.icon = icon;
      this.dialogAlert = true;
    },
    close() {
      this.dialogAlert = false;
      location.reload();
    },
    confirm() {
      if (
        this.form.file_upload_base64 !== null &&
        this.form.file_upload_base64 !== ""
      ) {
        if (this.form.type !== null && this.form.type !== "") {
          if (this.form.arcode !== null) {
            this.dialog_confirm = true;
          } else {
            alert("กรุณาเลือกลูกหนี้ก่อน");
          }
        } else {
          alert("กรุณาเลือกประเภทของเอกสารก่อน");
        }
      } else {
        alert("กรุณาเพิ่มไฟล์เอกสารก่อน");
      }
    },
    zoomDoc(_url) {
      if (this.$session.get("role") === "Customer") {
        window.open(_url);
      } else {
        window.open(this.allFiles[this.slide_carousel].doc_name);
      }
    },
    delDoc() {
      let path_del = "";
      let file_del = "";
      if (this.$session.get("role") === "Customer") {
        path_del = "../../var/www/html/partners/";
        file_del =
          this.allFiles[this.slide_carousel].doc_name.split("/partners/")[1];
      } else {
        path_del = "../../var/www/html/kmpimages/";
        file_del =
          this.allFiles[this.slide_carousel].doc_name.split("/kmpimages/")[1];
      }
      this.$axios
        .post(this.api + "/del/file", {
          id: this.allFiles[this.slide_carousel].doc_id,
          customer_id: this.select_customer.id,
          customer_name: this.select_customer.name,
          project_id: this.select_project.id,
          project_code: this.select_project.code,
          project_name: this.select_project.name,
          path_upload: path_del,
          filename: file_del,
          file_type: this.type_show,
          role: this.$session.get("role"),
          username_log: this.$session.get("username"),
          fullname: this.$session.get("fullname"),
          version_log: this.version,
          ipaddress_log: this.$session.get("ipaddress"),
          browser_log:
            this.$browserDetect.meta.name +
            " V." +
            this.$browserDetect.meta.version,
        })
        .then((res) => {
          if (res.data.status) {
            location.reload();
          } else {
            alert(res.data.error);
          }
        });
    },
    getAllFiles() {
      this.$axios
        .post(this.api + "/all/files", {
          customer_id: this.select_customer.id,
          project_id: this.select_project.id,
          username_log: this.$session.get("username"),
          version_log: this.version,
          ipaddress_log: this.$session.get("ipaddress"),
          browser_log:
            this.$browserDetect.meta.name +
            " V." +
            this.$browserDetect.meta.version,
          role: this.$session.get("role"),
          status: this.$session.get("status"),
        })
        .then((res) => {
          if (res.data.status) {
            if (res.data.response.length !== 0) {
              this.user = res.data.response[0].fullname;
              this.time = res.data.response[0].doc_datetime.replace(/-/g, " ");
              this.type_show = res.data.response[0].name_type;
              this.allFiles = res.data.response;
              console.log(this.allFiles);
            }
          } else {
            alert("ไม่สามารถเรียกข้อมูลได้");
          }
        });
    },
    inputFile() {
      let reader = new FileReader();
      reader.readAsDataURL(this.form.file_upload[0]);
      reader.onload = () => {
        this.form.file_upload_base64 = reader.result;
        this.dialog_preview = true;
      };
    },
    getAllCustomers() {
      this.$axios
        .post(this.api + "/all/customers", { level: this.customer_level })
        .then((res) => {
          if (res.data.status) {
            this.datasets_customer = res.data.response;
          } else {
            this.msgAlert(res.data.error, "mdi-alert-circle");
          }
        });
    },
    getCustomerID(customer_selected) {
      this.dialog_load = true;
      this.select_customer.id = customer_selected.taxid;
      this.select_customer.name = customer_selected.cust_name;
      this.current_step = 2;
      this.getAllProjectsByCustomer();
    },
    getArCode(db, server) {
      this.$axios
        .post(this.api + "/arcode", {
          db: db,
          server: server,
        })
        .then((res) => {
          if (res.data.status) {
            this.arcode = res.data.response;
          }
        });
    },
    getAllProjectsByCustomer() {
      this.$axios
        .post(this.api + "/all/projects/byCustomer", {
          customer_id: this.select_customer.id,
        })
        .then((res) => {
          if (res.data.status) {
            this.datasets_project = res.data.response;
          } else {
            alert(res.data.error);
            location.reload();
          }
        });
    },
    getProjectID(project_selected) {
      this.dialog_load = true;
      this.select_project.id = project_selected.project_id;
      this.select_project.name = project_selected.project_shortname;
      this.select_project.code = project_selected.project_code;
      this.getAllFiles();
      if (this.$session.get("role") === "Customer") {
        this.current_step = 2;
      } else {
        this.current_step = 3;
      }
    },
    backToProject() {
      this.search_project = "";
      this.select_project.id = null;
      this.select_project.name = null;
      this.select_project.code = null;
      this.uploadFiles = [];
      this.allFile = [];
      if (this.$session.get("role") == "Customer") {
        this.current_step = 1;
      } else {
        this.current_step = 2;
      }
    },
    backToCustomer() {
      this.search_customer = "";
      this.select_customer.id = null;
      this.select_customer.name = null;
      this.datasets_project = [];
      this.current_step = 1;
    },
    uploadFiles() {
      this.form.name_type =
        this.types_select[
          this.findWithAttr(this.types_select, "type", this.form.type)
        ].name_type;
      this.form.username_upload = this.$session.get("username");
      this.form.fullname_upload = this.$session.get("fullname");
      if (this.$session.get("role") === "Customer") {
        const index = this.findWithAttr(this.arcode, "Code", this.form.arcode)
        this.form.ar_name = this.arcode[index].Name1
        this.form.path_upload = "../../var/www/html/partners";
      } else {
        this.form.path_upload = "../../var/www/html/kmpimages";
      }
      this.form.status = this.$session.get("status");
      this.form.customer_id = this.select_customer.id;
      this.form.customer_name = this.select_customer.name;
      this.form.project_id = this.select_project.id;
      this.form.project_code = this.select_project.code;
      this.form.project_shortname = this.select_project.name;
      this.form.ipaddress = this.$session.get("ipaddress");
      this.form.browser =
        this.$browserDetect.meta.name +
        " V." +
        this.$browserDetect.meta.version;
      this.form.version = this.version;
      this.form.role = this.$session.get("role");
      this.$axios.post(this.api + "/uploadfile", this.form).then((res) => {
        if (res.data.status) {
          location.reload();
        } else {
          alert(res.data.error);
        }
      });
    },
    findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
  },
};
</script>

<style>
.select-style {
  font-size: 14px !important;
}
.v-list-item__title {
  font-size: 14px !important;
}
.upload-page {
  height: 100%;
}
.upload-box {
  height: 100%;
  background-color: #ffffed;
}
.size-box {
  height: 80vh;
  margin: 3%;
}
</style>